import "./pagination.scss";

import { Link } from "gatsby";
import React, { useEffect } from "react";

import PaginationModal from "./PaginationModal";

import { useHamburger } from "context/hamburger";

const Mobile = ({ current_page = 1, num_pages = 1, uri }) => {
  const { isPaginationOpen, setIsPaginationOpen } = useHamburger();

  useEffect(() => {
    document.body.classList.add("mobile-menu--open");

    return () => document.body.classList.remove("mobile-menu--open");
  }, []);

  const prevPage =
    current_page - 1 === 1
      ? uri
      : `${uri}page/${(current_page - 1).toString()}`;
  const nextPage = (current_page + 1).toString();

  return (
    <>
      <div className="pagination-mobile">
        <div className="pagination-mobile__num-container">
          <div
            onClick={() => setIsPaginationOpen(true)}
            className="pagination-mobile__number pagination-mobile__number--search"
          >
            <img src={require("assets/icons/searcher.svg").default} alt="" />
          </div>
          {num_pages >= 1 && (
            <Link
              to={`${uri}`}
              className={`pagination-mobile__number ${
                current_page === 1 ? "pagination-mobile__number--current" : ""
              }`}
            >
              1
            </Link>
          )}
          {num_pages >= 2 && (
            <Link
              to={`${uri}page/2/`}
              className={`pagination-mobile__number ${
                current_page === 2 ? "pagination-mobile__number--current" : ""
              }`}
            >
              2
            </Link>
          )}
          {num_pages >= 3 && (
            <Link
              to={`${uri}page/${num_pages}/`}
              className={`pagination-mobile__number ${
                current_page === num_pages
                  ? "pagination-mobile__number--current"
                  : ""
              }`}
            >
              {num_pages}
            </Link>
          )}
        </div>
        <div className="pagination-mobile__arrows">
          <Link to={prevPage} className="pagination-mobile__prev">
            <img
              src={require("assets/icons/arrow-right--new.svg").default}
              alt=""
            />
          </Link>
          <Link
            to={`${uri}page/${nextPage}/`}
            className="pagination-mobile__next"
          >
            <img
              src={require("assets/icons/arrow-right--new.svg").default}
              alt=""
            />
          </Link>
        </div>
      </div>
      {!!isPaginationOpen && (
        <PaginationModal current_page={current_page} count={num_pages} />
      )}
    </>
  );
};

export default Mobile;
